import { initializeApp, FirebaseOptions } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// import { v4 as uuidv4 } from "uuid";


// function getUserID() {
//   // Check if the User ID is already cached in localStorage
//   const cachedUserID = localStorage.getItem("user_id");

//   if (cachedUserID) {
//     // If the User ID is cached, return the cached value
//     return cachedUserID;
//   }
//   // Generate a new User ID using uuid v4
//   const newUserID = uuidv4();

//   // Cache the new User ID in localStorage
//   localStorage.setItem("user_id", newUserID);

//   return newUserID;
// }

/**
 * @type {FirebaseOptions}
 */
const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and get a reference to the service
const analytics = getAnalytics(app);

// try {
//   setUserId(analytics, getUserID());
// } catch (error) {
//   console.error("setUserId error: ", error);
// }

function trackEvent(eventName, eventParams = {}, analyticsOptions) {
  logEvent(analytics, eventName, eventParams, analyticsOptions);
}

export { analytics, logEvent, trackEvent };
